import { Injectable } from '@angular/core';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';

@Injectable()
export class CurrentDayService {
  public readonly DAILY_LOG_KEY: string = 'daily_log_key';

  constructor() {
  }

  public getCurrentLogDayFromLocalStorage(): string {
    return localStorage.getItem(this.DAILY_LOG_KEY);
  }

  public setCurrentLogDayInLocalStorage(isoDateString: string) {
    localStorage.setItem(this.DAILY_LOG_KEY, isoDateString);
  }

}



// WEBPACK FOOTER //
// ./src/services/date/current-day.service.ts